module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/contact_details-3878bf965be360ca6ce6ab0c8d49c196.png";